import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import { getTotalPoints } from '../../../state-management/accessors/lobbyAccessors';
import { cntrlGetTotalPoints } from '../../../state-management/actions/lobbyActions';
import { getUserInfo } from '../../../state-management/accessors/usersAccessors';
import useTranslation from '../../../core/customHooks/useTranslation';
import t from '../../../core/staticData/translation.json';
import PartnerModule from '../../../core/moduls/PartnerModul';
import { APP_CONSTANTS } from '../../../core/constants/constants';
import { getPartnerSettings } from "../../../state-management/accessors/partnerAccessors";

const UserTotalPoints = ({ activeUser, totalPoints, getTotalPoints, displayID }) => {
  const translate = useTranslation();

  function getCurrentMonthDates() {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    };

    const partnerId = PartnerModule.getConfigItem(APP_CONSTANTS.PARTNER_ID);

    return {
      start: formatDate(firstDay),
      end: formatDate(today),
      partnerId: partnerId
    };
  }

  useEffect(() => {
    getTotalPoints(getCurrentMonthDates())
  }, [])


  const monthlyPoints = totalPoints.userTotalPoints ? [ totalPoints.userTotalPoints, ...totalPoints.usersTotalPoints ] : totalPoints.usersTotalPoints

  return (
    <div className="global-container">
      <div className="inside-global-c-wr">
        <div className="top-of-inside-global-c-wr">
          <div className="info-row title">
            <div className="info-cell title">#</div>
            <div className="info-cell title">{ translate(t.USER) }</div>
            <div className="info-cell title">{ translate(t.POINTS) }</div>
          </div>
        </div>
        <div className="bottom-of-inside-global-c-wr scroll-wr">

          <div className="global-wrapper">
            { monthlyPoints?.map(( user, i ) => (
              <div className="leaderboard-row-wr">
                <div className={ `info-row item total-points ${activeUser.id === user.id ? "active" : '' }` }>
                  <div className="info-cell">{ i + 1 }</div>
                  <div className="info-cell">{ displayID ? user?.id : user?.nickName }</div>
                  <div className="info-cell">{ user?.totalPoints }</div>
                </div>
              </div>
            )) }
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  activeUser: getUserInfo(state),
  totalPoints: getTotalPoints(state),
  displayID: getPartnerSettings(state).displayId,
});

const mapDispatchToProps = dispatch => ({
  getTotalPoints: payload => dispatch(cntrlGetTotalPoints(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(UserTotalPoints));

